function Loader() {
  return (
    <div className="loader-wrap">
      <div className="spinner" />
      Loading…
    </div>
  );
}

export default Loader;
